export default __webpack_public_path__ + "c795e1ed49ff48a8e9d9cb665ab82695.svg";